// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { checkIsCategoryList, checkIsExplicitBlankVote, checkIsInvalidVote, isAcclaimedContest, } from "@sequentech/ui-core";
import { ESlateSelectionStatus, getSlateMembers, getSlateSelectionSummary } from "./SlateSelection";
var getSelectedCandidateIds = function (contest, selection) {
    var decoded = selection === null || selection === void 0 ? void 0 : selection.find(function (entry) { return entry.contest_id === contest.id; });
    if (!decoded) {
        return [];
    }
    return contest.candidates
        .filter(function (candidate) {
        return !checkIsExplicitBlankVote(candidate) &&
            !checkIsInvalidVote(candidate) &&
            !checkIsCategoryList(candidate);
    })
        .filter(function (candidate) {
        return decoded.choices.some(function (choice) { return choice.id === candidate.id && choice.selected > -1; });
    })
        .map(function (candidate) { return candidate.id; });
};
/**
 * What the review screen says about a ballot with slates, read from the
 * ordinary candidate selections. No slate choice is stored anywhere, so a
 * slate that was chosen and then changed by hand is reported as it is now.
 */
export var getBallotReviewSummary = function (contests, slates, selection) {
    var counted = contests.filter(function (contest) { return !isAcclaimedContest(contest); });
    var _a = getBallotSelectionCount(counted, selection), selected = _a.selected, seats = _a.seats;
    return {
        selected: selected,
        seats: seats,
        contests: Object.fromEntries(counted.map(function (contest) { return [
            contest.id,
            {
                selected: getSelectedCandidateIds(contest, selection).length,
                max: contest.max_votes,
            },
        ]; })),
        label: getBallotSelectionLabel(slates, selection),
    };
};
/** How many candidates the ballot holds, out of how many it may hold. */
/** How many candidates a contest holds. */
export var getContestSelectionCount = function (contest, selection) { return getSelectedCandidateIds(contest, selection).length; };
export var getBallotSelectionCount = function (contests, selection) {
    return contests
        .filter(function (contest) { return !isAcclaimedContest(contest); })
        .reduce(function (count, contest) { return ({
        selected: count.selected + getSelectedCandidateIds(contest, selection).length,
        seats: count.seats + contest.max_votes,
    }); }, { selected: 0, seats: 0 });
};
export var EBallotSelectionLabel;
(function (EBallotSelectionLabel) {
    EBallotSelectionLabel["SLATE"] = "slate";
    EBallotSelectionLabel["INDIVIDUAL"] = "individual";
    EBallotSelectionLabel["NONE"] = "none";
})(EBallotSelectionLabel || (EBallotSelectionLabel = {}));
/** What the ballot holds as a whole: exactly one slate, other choices, or nothing. */
export var getBallotSelectionLabel = function (slates, selection) {
    var exact = slates.slates.find(function (slate) {
        return getSlateSelectionSummary(getSlateMembers(slate), selection).status ===
            ESlateSelectionStatus.ALL;
    });
    if (exact) {
        return { kind: EBallotSelectionLabel.SLATE, slate: exact };
    }
    var hasChoice = (selection !== null && selection !== void 0 ? selection : []).some(function (contest) {
        return contest.is_explicit_invalid || contest.choices.some(function (choice) { return choice.selected > -1; });
    });
    return { kind: hasChoice ? EBallotSelectionLabel.INDIVIDUAL : EBallotSelectionLabel.NONE };
};
